import React, { useState } from 'react';
import { LiveIndicator } from '../components/LiveIndicator';
import { VideoPlayer } from '../components/VideoPlayer';
import { CountdownTimer } from '../components/CountdownTimer';
import { ActionButton } from '../components/ActionButton';
import { GiftIcon, X } from 'lucide-react';
import { BonusCard } from '../components/BonusCard';
import { PricingCard } from '../components/PricingCard';
import { ValueSummary } from '../components/ValueSummary';
import { CompleteSystemOffer } from '../components/CompleteSystemOffer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { FAQ } from '../components/FAQ';
import { CaseStudyVideo } from '../components/CaseStudyVideo';
import { TestimonialSection } from '../components/TestimonialSection';
export function ReplayPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <div className="min-h-screen" data-id="element-4534" data-mp="1aopk70lcupcy">
      {/* Dark section - Header, Video, CTA */}
      <div className="bg-gradient-to-b from-gray-900 to-black text-white" data-id="element-4535" data-mp="367usvxo9ztlc">
        <div className="container mx-auto px-4 py-12 max-w-5xl" data-id="element-4536" data-mp="3b7pky4jsep7z">
          <div className="flex justify-center mb-6" data-id="element-4537" data-mp="3ba29x1nypzuj">
            <LiveIndicator data-id="element-4538" data-mp="3g6smvg4h0fbq" />
          </div>
          <div className="text-center mb-8" data-id="element-4539" data-mp="3g4zg80tuxv3q">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-4540" data-mp="3l6f400nf6fpt">
              Cómo Generar de $500-$1000/día con el poder de la Inteligencia
              Artificial
            </h1>
            <p className="text-xl text-gray-300 mt-4" data-id="element-4541" data-mp="2sgybl2zsuytl">
              Masterclass exclusiva: Aprende estrategias probadas para generar
              ingresos con IA
            </p>
          </div>
          <div className="overflow-hidden mb-8" style={{
          boxShadow: '0 0 40px rgba(34, 197, 94, 0.6), 0 0 80px rgba(34, 197, 94, 0.4), 0 20px 100px rgba(34, 197, 94, 0.3)'
        }} data-id="element-4542" data-mp="327t3amvteqmf">
            <VideoPlayer data-id="element-4543" data-mp="29qgopf1nexg5" />
          </div>
          <div className="mt-8 text-center pb-12" data-id="element-4544" data-mp="29pfbp512o0vs">
            <CountdownTimer data-id="element-4545" data-mp="21q0yf45hwwv8" />
            <div className="mt-8" data-id="element-4546" data-mp="21p92ttbwez4y">
              <ActionButton data-id="element-4547" data-mp="21o7nhcnunqhf" />
            </div>
          </div>
        </div>
      </div>
      {/* White section - Bonus images and gift button */}
      <div className="bg-white" data-id="element-4548" data-mp="2bgdfgme3q7wm">
        <div className="container mx-auto px-4 py-12 max-w-5xl" data-id="element-4549" data-mp="2bfkigd4y2wro">
          <div className="mt-8" data-id="element-4550" data-mp="26gr1gaqg8nmr">
            <PricingCard data-id="element-4551" data-mp="26hiylpzp2tf5" />
            {/* Case Study Video */}
            <CaseStudyVideo data-id="element-4552" data-mp="1iqmzs8wtmxye" />
            {/* Testimonial Section */}
            <TestimonialSection data-id="element-4553" data-mp="1dsd47x76pvc9" />
            <BonusCard bonusNumber={1} title="BOVEDA DE AI PROMPTS" description="Más de 1,000 prompts probados y optimizados para IA. Copia y pega para obtener resultados instantáneos en tus campañas y contenidos." imageSrc="https://cdn.magicpatterns.com/uploads/xi8Aqi4p2fcNffNAdv6eaW/Screenshot_2026-01-08_at_11.01.25_PM.png" data-id="element-4554" data-mp="1dt4woz5hjcyb" />
            <BonusCard bonusNumber={2} title="AI PRODUCT ROLODEX" description="La Lista de 60 productos digitales y nichos validados listos para lanzar. Nicho, avatar, targeting, ads, todo." imageSrc="https://cdn.magicpatterns.com/uploads/dQQyhq5ofiFSdVHXGevL5m/Screenshot_2026-01-08_at_11.00.51_PM.png" data-id="element-4555" data-mp="34380bketz9am" />
            <BonusCard bonusNumber={3} title="PLANTILLAS DFY COPYWRITING" description="Plantillas DFY Copy hechas para ti." features={['VSL Scripts', 'Sales Copywriting', 'Email and SMS copy', 'Abandonment Cart']} imageSrc="https://cdn.magicpatterns.com/uploads/rjrfMP1TNvhRaA5Ge8vaTi/c760a89c-ca2b-42bf-9bb2-fffe9652a3d5.png" data-id="element-4556" data-mp="3bplk4sreazys" />
            <BonusCard bonusNumber={4} title="AI INCOME CALCULATOR" description="Calculadora para calcular los ingresos de tu funnel y productos digitales." features={['Click Roas', 'AOV', 'LTV']} imageSrc="https://cdn.magicpatterns.com/uploads/sbsgqc4DbHfc6rMsr661hd/0b3c81b5-279c-4857-99ab-94f80e2fc784.png" data-id="element-4557" data-mp="3ues3mi00jvln" />
            <BonusCard bonusNumber={5} title="VIRAL VIDEO MACHINE" description="Crea Videos Virales con AI. Sin grabar, sin editar, sin diseñar. Nada. Todo hecho por IA." features={['Videos que han tenido millones de views y ventas']} imageSrc="https://cdn.magicpatterns.com/uploads/v1Fv9jrn3PZg3qgffKZ7PN/f2daf09f-8d0d-419a-a6db-476b7c45c64e.png" data-id="element-4558" data-mp="c9f1wquhye6k" />
            <ValueSummary data-id="element-4559" data-mp="2kgjypwt73ia1" />
            <CompleteSystemOffer data-id="element-4560" data-mp="2kk7qaqf2xum4" />
          </div>
          {/* FAQ Section */}
          <FAQ data-id="element-4561" data-mp="2fkuvnjhyvj8z" />
          <div className="text-center mt-8" data-id="element-4562" data-mp="2fkldgi35ygdu">
            <ActionButton data-id="element-4563" data-mp="2bi8ag1fswwkr" />
          </div>
          <div className="text-center mt-8" data-id="element-4564" data-mp="2bj9kq3oztf1f">
            <a href="https://regalo.marketingconia.live/" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-bold py-4 px-8 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-xl" data-id="element-4565" data-mp="387pekbz4yakc">
              <GiftIcon className="w-6 h-6" data-id="element-4566" data-mp="3qxxd0grw4cu7" />
              ¡Reclama Tu Regalo Gratis!
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-800" data-id="element-4567" data-mp="3m5xi52qoga4h">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-4568" data-mp="18pw1edbyo5ox">
          {/* Legal Disclaimer */}
          <div className="text-gray-400 text-[10px] leading-tight space-y-2 text-left" data-id="element-4569" data-mp="1do7cerdzsm8q">
            <p data-id="element-4570" data-mp="1hohh80q1t6m0">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-4571" data-mp="2afhmsg412ifs">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-4572" data-mp="p25ugb8v4cn7">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-4573" data-mp="u1qtsmry2n0g">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-4574" data-mp="39qsjykrw6423">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-4575" data-mp="34sikvz31qjb7">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-800" data-id="element-4576" data-mp="1p7q4ff4z6c92">
            <p className="text-gray-600 text-[10px] mb-1" data-id="element-4577" data-mp="1ak55zyj1p17h">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-[10px] mb-1" data-id="element-4578" data-mp="1fh5ba782lzxj">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-4579" data-mp="11hm35ef9eol8">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-4580" data-mp="rmkc2d1fbcg0">
              <button onClick={() => setShowTerms(true)} className="text-gray-500 hover:text-white transition-colors underline" data-id="element-4581" data-mp="wl5cacgodw4g">
                Términos
              </button>
              <span className="text-gray-600" data-id="element-4582" data-mp="2qyn5og3rhn7e">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-500 hover:text-white transition-colors underline" data-id="element-4583" data-mp="2qxbys7f0rzc2">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-4584" data-mp="14xnkr048lpl1" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-4585" data-mp="100drf9dq8trx">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-4586" data-mp="v1ka15vbkimh">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-4587" data-mp="lzuk64h35rqt">
              <X className="w-6 h-6" data-id="element-4588" data-mp="h2b552ckdaxt" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-4589" data-mp="2gdvfwghc9ymo">
              Términos y Condiciones
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-4590" data-mp="2bg2es1uw7ut9">
              <p data-id="element-4591" data-mp="2izbjhhsgf5bz">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4592" data-mp="2sntjhwswt8ek">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-4593" data-mp="2xm4s647gxcv7">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4594" data-mp="250lms39jr7o5">
                2. Uso del Servicio
              </h3>
              <p data-id="element-4595" data-mp="2exho9p112tj7">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4596" data-mp="3qak5mmaybn4f">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-4597" data-mp="3pqggmugxch2f">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4598" data-mp="36tf0qelu0wjp">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-4599" data-mp="3aw1u4jy5ipj0">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4600" data-mp="3kqtu1uf7hogy">
                5. Modificaciones
              </h3>
              <p data-id="element-4601" data-mp="102paxacjzrnp">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4602" data-mp="2fmos1edzwbhq">Contacto</h3>
              <p data-id="element-4603" data-mp="2atvouuy6db7r">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-4604" data-mp="25v2al0b2dg6j">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-4605" data-mp="1rw2oo0exrfe2">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-4606" data-mp="1myj7osqusoif">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-4607" data-mp="3hb90f75hjro8">
              <X className="w-6 h-6" data-id="element-4608" data-mp="1flba16xdity8" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-4609" data-mp="1kcjkm6afwlcz">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-4610" data-mp="15oyj2gt7qu76">
              <p data-id="element-4611" data-mp="1am8i8o6emk87">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4612" data-mp="23aw52o6sxhnv">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-4613" data-mp="1tdhtb1vtph1w">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-4614" data-mp="dvoffjji9zi5">
                <li data-id="element-4615" data-mp="hy2s1lwl030z">Nombre y dirección de correo electrónico</li>
                <li data-id="element-4616" data-mp="hw89ge8s8n02">Información de registro del evento</li>
                <li data-id="element-4617" data-mp="adsabvyg1vxw">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4618" data-mp="5gib5ol965wv">
                2. Uso de la Información
              </h3>
              <p data-id="element-4619" data-mp="kbokoljk4muy">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-4620" data-mp="fdwovgfskglh">
                <li data-id="element-4621" data-mp="feoemampjk3u">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-4622" data-mp="3iun2agdpdvx7">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-4623" data-mp="3iw6kicix6h1m">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-4624" data-mp="1en8afnobkgz">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4625" data-mp="3sst46xzif222">
                3. Compartir Información
              </h3>
              <p data-id="element-4626" data-mp="352f7uv9w6h1o">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4627" data-mp="27du65y0qyo01">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-4628" data-mp="2ccdta1r2u5tz">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4629" data-mp="2m5kv5cmlz3pb">
                5. Tus Derechos
              </h3>
              <p data-id="element-4630" data-mp="2v3wsrylw71r9">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-4631" data-mp="300x16g67sglj">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4632" data-mp="15p8ji68llzxg">6. Cookies</h3>
              <p data-id="element-4633" data-mp="y691a3wviefo">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-4634" data-mp="ogphmw1c6gjr">Contacto</h3>
              <p data-id="element-4635" data-mp="jgunmjm9lauh">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-4636" data-mp="1h439wgu3anxj">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}